import React,{Component} from 'react';
import WorkTagView from './WorkTagView';
class WorkerView extends Component{

  constructor(props){
    super(props);
  }

  render(){
    if(this.props.showWorkerButton == true){  
    return (
        <div>
      
          <WorkTagView closeApplication={this.props.closeApplication} setToWork={this.props.setToWork} working={this.props.working} setToOutOfWork={this.props.setToOutOfWork}/>

      </div>
      )
    }else{
      return (
        <div>
      
         
      </div>
      )
    }

  }
}
export default WorkerView;
